import React from 'react';
import HiddenBase from '@material-ui/core/Hidden';

const Hidden = (props) => <HiddenBase {...props} />;

export default Hidden;
